<template>
  <div id="app">
    <NavigationBar />
    <router-view />
  </div>
</template>

<script>
import NavigationBar from './components/Navigation.vue'

export default {
  name: 'App',
  components: {
    NavigationBar
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: #E5E7EB;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.16) 0, transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.22) 0, transparent 55%),
    #020617;
  background-attachment: fixed;
}

#app {
  min-height: 100vh;
  position: relative;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #020617;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #22D3EE, #6366F1, #A855F7);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #06B6D4, #4F46E5, #C084FC);
}

/* Smooth animations for all elements */
* {
  transition: all 0.3s ease;
}

/* Focus styles for accessibility */
button:focus,
a:focus {
  outline: 2px solid #22D3EE;
  outline-offset: 2px;
}

/* Loading animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

/* Utility classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.gradient-text {
  background: linear-gradient(135deg, #22D3EE, #6366F1, #A855F7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* Responsive typography */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
}

/* Print styles */
@media print {
  .navigation,
  .footer {
    display: none;
  }
}
</style>
